import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Cluster } from 'src/app/models/cluster.model';
import { Subscription } from 'rxjs';
import { ClustersService } from 'src/app/services/clusters.service';

@Component({
  selector: 'app-strategy-builder',
  templateUrl: './strategy-builder.component.html',
  styleUrls: ['./strategy-builder.component.scss']
})
export class StrategyBuilderComponent implements OnInit, OnDestroy {

  selectedStep: string;
  selectBlock: string = '';
  currentCluster: Cluster;

  panelOpenState = false;

  currentClusterSubscription: Subscription;

  constructor(private route: ActivatedRoute,
              private clustersService: ClustersService) {}

  ngOnInit(): void {
    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (currentCluster: Cluster) => {
        this.currentCluster = currentCluster;
      }
    );
    this.clustersService.emitCurrentCluster();

    this.route.params.subscribe(
      params => {
        if (this.route.snapshot.params['step']) {
          this.selectedStep = params['step'];
        } else {
          this.selectedStep = 'universe';
        }
      }
    );
  }

  ngOnDestroy() {
    if(this.currentClusterSubscription!=undefined) { this.currentClusterSubscription.unsubscribe(); }
  }

  onChangeBlock(selectBlock: string) {
    this.selectBlock = selectBlock;
  }

}
